import $ from 'jquery'

$( document ).ready( function () {
  $( function () {
    $( '.product-item, .review-single, .faq-single, .rc_label, .sub-boxes__inner, .prepaid-label' ).matchHeight()
  } )

  jQuery( '.menu-icon' ).click( function () {
    jQuery( '.slideout-menu' ).addClass( 'slideout-menu-open' )
    jQuery( '.mask' ).addClass( 'mask-show' )
    jQuery( 'body' ).addClass( 'stuck' )
  } )

  jQuery( '.menu-close' ).click( function () {
    jQuery( '.slideout-menu' ).removeClass( 'slideout-menu-open' )
    jQuery( '.mask' ).removeClass( 'mask-show' )
    jQuery( 'body' ).removeClass( 'stuck' )
  } )

  jQuery( '.mask' ).click( function () {
    jQuery( '.slideout-menu' ).removeClass( 'slideout-menu-open' )
    jQuery( '.mask' ).removeClass( 'mask-show' )
    jQuery( 'body' ).removeClass( 'stuck' )
  } )

  //root menu

  jQuery( '.menu-icon-root' ).click( function () {
    jQuery( '.slideout-menu-root' ).addClass( 'slideout-menu-root-open' )
    jQuery( '.mask' ).addClass( 'mask-show' )
    jQuery( 'body' ).addClass( 'stuck' )
  } )

  jQuery( '.menu-close-root' ).click( function () {
    jQuery( '.slideout-menu-root' ).removeClass( 'slideout-menu-root-open' )
    jQuery( '.mask' ).removeClass( 'mask-show' )
    jQuery( 'body' ).removeClass( 'stuck' )
  } )

  jQuery( '.mask' ).click( function () {
    jQuery( '.slideout-menu-root' ).removeClass( 'slideout-menu-root-open' )
    jQuery( '.mask' ).removeClass( 'mask-show' )
    jQuery( 'body' ).removeClass( 'stuck' )
  } )

  $( '.js-modal-btn' ).modalVideo( { channel: 'youtube' } )

  $( function ( $ ) {
    $( window ).scroll( function () {
      var yPos = ($( window ).scrollTop())

      if ( yPos > 800 ) { // Show element after this amount of scrolled down pixels

        $( '.up-arrow' ).fadeIn()
      } else {
        $( '.up-arrow' ).fadeOut()
      }
    } )
  } )

  $( '.sub-menu-link' ).click( function ( e ) {
    e.preventDefault()
    $( this ).toggleClass( 'active' )
  } )

  $( '.dropdown-menu a' ).click( function () {
    $( this ).parents( '.dropdown' ).find( '.dropdown-toggle' ).html( $( this ).text() )
    $( this ).parents( '.dropdown' ).find( '.dropdown-toggle' ).val( $( this ).data( 'value' ) )
  } )

  $( '.product-slider' ).slick( {
    // normal options...
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    asNavFor: '.product-slider-nav',
  } )
  $( '.product-slider-nav' ).slick( {
    // normal options...
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    asNavFor: '.product-slider',
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
  } )

  /*Product Sticky  Section Nav>*/
  // Do our DOM lookups beforehand
  var nav_container = $( '.sticky-nav-container' )
  nav_container.waypoint( {
    handler: function ( direction ) {
      if ( direction === 'down' ) {
        nav_container.addClass( 'sticky' )
      } else {
        nav_container.removeClass( 'sticky' )
      }
    },
    offset: -20,
  } )

  var sections         = $( '.product-section' )
  var navigation_links = nav_container.find( 'a.sticky-nav-link' )

  var sectionHandler = function ( direction ) {
    navigation_links.removeClass( 'selected' )
    var active_link = $( '.product-nav a[href="#' + $( this.element ).attr( 'id' ) + '"]' )
      .addClass( 'selected' )
  }

  sections.each( function () {
    var section = $( this )
    new Waypoint.Inview( {
      element: section.get( 0 ),
      entered: sectionHandler,
      exit: sectionHandler,
    } )
  } )


  $( window ).resize( function () {
    Waypoint.refreshAll()
  } )

  setTimeout( function () {
    Waypoint.refreshAll()
  }, 1000 )

  //by this time all js controlled elements would have been loaded, so calculation of offset would need to be redone


  /*<Product Sticky  Section Nav*/


  // Select all links with hashes
  $( 'a[href*="#"]' )
    // Remove links that don't actually link to anything
    .not( '[href="#"]' )
    .not( '[href="#0"]' )
    .click( function ( event ) {
      // On-page links
      if (
        location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' )
        &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $( this.hash )
        target     = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' )
        // Does a scroll target exist?
        if ( target.length ) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault()
          $( 'html, body' ).animate( {
            scrollTop: target.offset().top,
          }, 1000, function () {
            // Callback after animation
            // Must change focus!
            var $target = $( target )
            $target.focus()
            if ( $target.is( ':focus' ) ) { // Checking if the target was focused
              return false
            } else {
              $target.attr( 'tabindex', '-1' ) // Adding tabindex for elements not focusable
              $target.focus() // Set focus again
            }

          } )
        }
      }
    } )

  //recharge

  /*
    if ( $( '.rc_block__type__autodeliver' ).hasClass( 'rc_block__type--active' ) ) {
      $( '.rc_block__type__options' ).addClass( 'delivery_show' )
    }
  */

  /* jQuery( '.rc_block__type__onetime' ).click( function () {
     if ( $( '.rc_block__type__onetime' ).hasClass( 'rc_block__type--active' ) ) {
       $( '.rc_block__type__options' ).removeClass( 'delivery_show' )
     }
   } )

   jQuery( '.rc_block__type__autodeliver' ).click( function () {
     if ( $( '.rc_block__type__autodeliver' ).hasClass( 'rc_block__type--active' ) ) {
       $( '.rc_block__type__options' ).addClass( 'delivery_show' )
     }
   } )*/

  $( '.rc_radio' ).on( 'change', function () {
    var $this        = $( this )
    var $typeOptions = $( '.rc_block__type__options' )

    $typeOptions.removeClass( 'delivery_show' )

    if ( $this.val() === 'autodeliver' ) {
      $typeOptions.addClass( 'delivery_show' )
    }
  } )
  $( '.rc_block__type--active input[name="purchase_type"]' ).change()

  /**
   * Add to Cart Modal
   */
  function buildAddToCartImg ( $modal, data ) {
    $modal.find( '.img-wrapper' ).html( '<img src="' + data.featured_image.url + '" alt="' + data.featured_image.alt + '" class="img-fluid" >' )
  }

  function buildAddToCartContent ( $modal, data ) {
    $modal.find( '.product-info-wrapper' ).html( '<span class="product-title">' + data.title + '</span>' )
  }

  function buildAddToCartPrice ( $modal, data ) {
    $modal.find( '.product-price-wrapper' ).html( '<span class="product-price">' + Shopify.formatMoney( data.price, '£{{amount}}' ) + '</span>' )
  }


  /*Product add to cart> */
  var $addToCartForm = $( '.add-to-cart-form, .shopify-product-form' )
  $addToCartForm.on( 'submit', function ( e ) {
    e.preventDefault()

    var $form           = $( this )
    var serialisedArray = $form.serializeArray()

    $.ajax( {
      url: $form.attr( 'action' ) + '.js',
      data: serialisedArray,
      processData: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      dataType: 'json',
      type: 'POST',
    } ).done( function ( data ) {
      //console.log('data', data)
      //build modal body
      var $modal     = $( '#addToCartModal' )
      var $modalBody = $modal.find( '.modal-body' )
      buildAddToCartImg( $modal, data )
      buildAddToCartContent( $modal, data )
      buildAddToCartPrice( $modal, data )

      //display popup
      $modal.modal()
    } ).fail( function ( data ) {
      //todo: build out
      //console.log( "failed addition to cart" )
    } )
  } )
  /*<Product add to cart */

  /*Update header cart>*/
  //We implement a global ajax complete handler so when any ajax call completed we would query cart for updates
  $( document ).ajaxComplete( function ( event, xhr, settings ) {
    //console.log( "ajaxComplete:", settings.url )
	var excludePaths = [ '/cart.js', '/cart.json' ];

    if ( excludePaths.indexOf(settings.url) < 0 ) {
      //console.log( "Triggered ajaxComplete handler. The result is ", xhr.responseText, settings.url )
      $( document ).trigger( 'minicart-before-update' )
      $.getJSON( '/cart.js' ).done( function ( data ) {
        var $miniCart                    = $( '#header-mini-cart' )
        var $cartCount                   = $miniCart.find( '.cart-count' )
        var $cartQty                     = $miniCart.find( '.cart-qty' )
        var $inner                       = $miniCart.find( '.cart_header__inner' )
        var isCartEmpty                  = (data.total_price === 0) && (data.item_count === 0)
        var $totalPriceMoneyWithCurrency = $( '.total_price_money_with_currency' )
        $( document ).trigger( 'minicart-updated', data )

        if ( $cartCount.length !== 0 || $cartQty.length !== 0 ) {
          $cartCount.remove()
          $cartQty.remove()
        }

        if ( !isCartEmpty ) {
          $inner.append( '<span class="cart-count">(' + data.item_count + ')</span> ' )
          $inner.append( '<span class="cart-count cart-qty">' + Shopify.formatMoney( data.total_price, '£{{amount}}' ) + '</span> ' )
        }

      } )
    }
  } )
  /*<Update header cart*/



  $( window ).resize() //force window resize event to help Waypoint to register any DOM changes
} )


//return to top on pge refresh
$( window ).on( 'beforeunload', function () {
  //$( window ).scrollTop( 0 )
} )

//once page loaded, update Waypoint to register the new viewport height
$( window ).on( 'load', function () {
  Waypoint.refreshAll()
} )


//slider and hover overs

function addActiveSlideClass ( info ) {
  const slides      = document.querySelectorAll( '.testimonial-slider-slides .testimonial-slider-slide' )
  const slideAsides = document.querySelectorAll( '.slider-aside' )

  slideAsides.forEach( function(slideAside) {
    slideAside.classList.remove( 'slider-aside-active' )
  } )

  slides.forEach( function( slide, index ) {
    slide.classList.remove( 'tns-slide-active-image' )

    if ( index === info.index ) {
      slide.classList.add( 'tns-slide-active-image' )

      var dataSlideIndex = slide.getAttribute( 'data-slide' )
      document.querySelector( '.slider-aside.slider-aside-' + dataSlideIndex ).classList.add( 'slider-aside-active' )
    }
  } )
}

window.addEventListener( 'DOMContentLoaded', function() {
  /**
   * testimonial-slider
   */

  const hasSlider = document.querySelector( '.testimonial-slider-slides' )

  if ( hasSlider ) {
    const slider = tns( {
      mode: 'carousel',
      container: '.testimonial-slider-slides',
      nav: false,
      controls: true,
      prevButton: '.testimonial-slider-prev',
      nextButton: '.testimonial-slider-next',
      slideBy: 1,
      items: 1.1,
      center: false,
      mouseDrag: true,
      autoplay: true,
      autoplayTimeout: 10000,
      // fixedWidth: 100,
      gutter: 16,
      lazyload: true,
      speed: 300,
      responsive: {
        576: {
          items: 1.5,
        },
        768: {
          items: 2,
        },
        1200: {
          items: 3,
        },
      },
    } )

    addActiveSlideClass( slider.getInfo() ) // on load
    slider.events.on( 'indexChanged', addActiveSlideClass )
  }
  /**
   * button-tooltips
   */

  const buttonTooltips = Array.from( document.querySelectorAll( '.button-tooltips' ) )

  buttonTooltips.forEach( function(buttonTooltip) {
    const buttonTooltipsBtns   = Array.from( buttonTooltip.querySelectorAll( '.button-tooltip-btn' ) )
    const buttonTooltipsPopups = Array.from( buttonTooltip.querySelectorAll( '.button-tooltip-popup' ) )

    buttonTooltipsBtns.forEach( function( buttonTooltipBtn, index ) {
      [ 'click', 'mouseover' ].forEach( function(event) {
        buttonTooltipBtn.addEventListener( event, function() {
          if ( event === 'click' && buttonTooltipBtn.classList.contains( 'active' ) ) {
            // deactivate
            buttonTooltipsBtns.forEach( function(btn) {
              btn.classList.remove( 'active' )
            } )
            buttonTooltipsPopups.forEach( function(popup) {
              popup.classList.remove( 'active' )
            } )
          } else {
            // activate

            // active btn
            buttonTooltipsBtns.forEach( function(btn) {
              btn.classList.remove( 'active' )
            } )

            buttonTooltipBtn.classList.add( 'active' )

            // active popup
            buttonTooltipsPopups.forEach( function(popup) {
              popup.classList.remove( 'active' )
            } )

            buttonTooltipsPopups[ index ].classList.add( 'active' )
          }
        } )

        buttonTooltipBtn.addEventListener( 'mouseleave', function() {
          if ( buttonTooltipBtn.classList.contains( 'active' ) ) {
            // deactivate
            buttonTooltipsBtns.forEach( function(btn) {
              btn.classList.remove( 'active' )
            } )
            buttonTooltipsPopups.forEach( function(popup) {
              popup.classList.remove( 'active' )
            } )
          }
        } )
      } )
    } )
  } )

} )



